import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class VisaCountryService {
  private apiUrl = `${environment.apiUrl}/visaCountry`; // apiUrl'ı güncelliyoruz

  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    const herader = {
      skipLoad: 'true',
    }
    return this.http.get<any>(this.apiUrl,{headers: herader});
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

}
